EBContext.modules.Autocompleter = function (options) {
	this.options = EBContext.utils.extendObj(false, {
		blockName: '',
		resultPathTemplate: EBContext.data.hrefMap.result_categoryseoid || '/categories/<!--$SEOID-->',
		detailPathTemplate: EBContext.data.hrefMap.detail_seoid || '/products/<!--$SEOID-->',
		manufacturerPathTemplate: EBContext.data.hrefMap.manufacturerdetail_seoid || '/manufacturers/<!--$SEOID-->',
		searchEl: '#autocompleterText',
		boxEl: '#autocompleterBox',
		selClass: 'bg-light',
		imgBackground: '',
		minLength: 3,
		searchTimeout: 300,
		loader: null,
		clearQuotes: true,
		ignoreAccent: false,
		goodTextMode: 'wrap',
		categoryTextMode: 'wrap',
		manufacturerTextMode: 'wrap',
		fnGenerateCategoryEl : cat => {
			let catId = EBContext.jsMenu.getCatID(cat.SEOID);
			let catObj = EBContext.jsMenu.getCatObj(catId);
			let catEl = EBContext.utils.template(
				'<a href="<!--#resultPath-->" class="col-12 border-top text-body py-1 text-decoration-none text-default" data-type="item"><!--#catContent--></a>', {
					catContent: '<div class="row gx-0 align-items-center"><div class="col-2 text-center" <!--$imgbg?#imgbg-->><!--#img--></div><div class="col-10 ps-2 d-flex align-items-center<!--$truncate?" text-truncate"-->" title="<!--$text-->"><!--$text--></div></div>',
					img: '<img class="autocompleteImg lazyload" data-sizes="auto" <!--$srcSet--> alt="<!--$text-->" onerror="this.src=\'<!--~noImage-->\';this.srcset=\'\';this.onerror=\'\'">',
					resultPath: self.options.resultPathTemplate
				}, {
					noImage: '/files/media/template/noimage.png',
					SEOID: cat.SEOID,
					text: EBContext.jsMenu.getCatPath(catId, 'Name').join(' / '),
					srcSet: (catObj.Photo && catObj.Photo.SrcSet ? catObj.Photo.SrcSet : ' src="/files/media/template/noimage.png"'),
					truncate: (self.options.categoryTextMode === 'truncate')
				}
			)[0];
			catEl.addEventListener('mouseleave', () => self.highlight(null), false);
			catEl.addEventListener('mouseenter', e => self.highlight(e.target), false);
			catEl.addEventListener('click', () => {
				self.close();
				if (self.options.resetOnSearch)
					self.searchEl.value = '';
				return true;
			}, false);
			return catEl;
		},
		fnGenerateManufacturerEl : manufacturer => {
			let imgSrc = (manufacturer.pic !== '' ? manufacturer.pic : '/files/media/template/noimage.png');

			let gEl = EBContext.utils.template(
				'<a href="<!--#manufacturerPath-->" class="col-12 border-top text-body py-1 text-decoration-none text-default" data-type="item"><!--#goodContent--></a>', {
					goodContent: '<div class="row gx-0 align-items-center"><div class="col-2 text-center"<!--$imgbg?#imgbg--> ><!--#img--></div><div class="col-10 ps-2 d-flex align-items-center" title="<!--$nazev-->"><!--#name--><!--#code--></div></div>',
					img: '<img class="autocompleteImg" src="<!--$img-->" alt="<!--$nazev-->" onerror="this.src=\'<!--~noImage-->\';this.srcset=\'\';this.onerror=\'\'">',
					name: '<div class="searchVal<!--$truncate?" text-truncate"-->"><!--$nazev--></div>',
					code: '<div class="small><!--$kod--></div>',
					imgbg: ' style="background:<!--$imgbg-->"',
					manufacturerPath: self.options.manufacturerPathTemplate
				}, {
					noImage: '/files/media/template/noimage.png',
					SEOID: manufacturer.SEOID,
					img: imgSrc,
					nazev: manufacturer.nazev,
					kod: EBContext.resource('KOD') + ': ' + manufacturer.cislo,
					imgbg: self.options.imgBackground,
					truncate: (self.options.manufacturerTextMode === 'truncate')
				}
			)[0];
			gEl.addEventListener('mouseleave', () => self.highlight(null), false);
			gEl.addEventListener('mouseenter', e => self.highlight(e.target), false);
			gEl.addEventListener('click', () => {
				self.close();
				if (self.options.resetOnSearch)
					self.searchEl.value = '';
				return true;
			}, {capture: true, passive: true});
			return gEl;
		},
		fnGenerateGoodEl: good => {
			let imgSrc = (good.pic !== '' ? good.pic : '/files/media/template/noimage.png');

			let gEl = EBContext.utils.template(
				'<a href="<!--#detailPath-->" class="col-12 border-top text-body py-1 text-decoration-none text-default" data-type="item"><!--#goodContent--></a>', {
					goodContent: '<div class="row gx-0 align-items-center"><div class="col-2 text-center"<!--$imgbg?#imgbg--> ><!--#img--></div><div class="col-10 ps-2 d-flex align-items-center" title="<!--$nazev-->"><!--#name--><!--#code--></div></div>',
					img: '<img class="autocompleteImg" src="<!--$img-->" alt="<!--$nazev-->" onerror="this.src=\'<!--~noImage-->\';this.srcset=\'\';this.onerror=\'\'">',
					name: '<div class="searchVal<!--$truncate?" text-truncate"-->"><!--$nazev--></div>',
					code: '<div class="small><!--$kod--></div>',
					imgbg: ' style="background:<!--$imgbg-->"',
					detailPath: self.options.detailPathTemplate
				}, {
					noImage: '/files/media/template/noimage.png',
					SEOID: good.SEOID,
					img: imgSrc,
					nazev: good.nazev,
					kod: EBContext.resource('KOD') + ': ' + good.cislo,
					imgbg: self.options.imgBackground,
					truncate: (self.options.goodTextMode === 'truncate')
				}
			)[0];
			gEl.addEventListener('mouseleave', () => self.highlight(null), false);
			gEl.addEventListener('mouseenter', e => self.highlight(e.target), false);
			gEl.addEventListener('click', () => {
				self.close();
				if (self.options.resetOnSearch)
					self.searchEl.value = '';
				return true;
			}, {capture: true, passive: true});
			return gEl;
		},
		initCallback: null
	}, options);

	this.timer;
	this.hidden = true;
	this.activeItem = null;
	this.value = '';

	this.history = {};
	this.goods = [];
	this.categories = [];
	this.manufacturers = [];
	this.loader = this.options.loader;
	this.submitTimestamp = 0;

	this.searchEl, this.boxEl, this.formEl, this.loaderEl;
	var self = this;
	var preserveCursorPosition = e => (['ArrowUp', 'ArrowDown'].indexOf(e.key) + 1 ? e.preventDefault() : true);

	this.init = function (options) {
		self.options = EBContext.utils.extendObj(false, self.options, options);
		self.searchEl = (self.options.searchEl instanceof Element ? self.options.searchEl : document.querySelector(self.options.searchEl));
		self.boxEl = (self.options.boxEl instanceof Element ? self.options.boxEl : document.querySelector(self.options.boxEl));
		self.boxEl.style.display = 'none';
		self.hidden=true;
		self.formEl = self.searchEl.closest('form');

		// self.searchEl.addEventListener('blur',()=>(self.boxEl.querySelector(':hover') === null ? self.close() : null));
		document.addEventListener('click', e=>(!self.hidden && e.target !== self.searchEl && !self.boxEl.contains(e.target) ? self.close() : null));
		document.addEventListener('EBContext.ajaxNav.navigate', self.close);
		
		self.searchEl.addEventListener('keyup', self.input);
		self.searchEl.addEventListener('keydown', preserveCursorPosition);
		self.searchEl.addEventListener('keypress', preserveCursorPosition);
		if(self.formEl)	EBContext.utils.element.setOverride(self.formEl, 'onsubmit', self.submit);
		
		
		self.loader = self.loader || new EBContext.modules.Loader({
			parentElement: self.boxEl,
			loaderClass: 'fas fa-spinner fa-spin',
			loaderType: 'append',
			prependLoader: false,
			disableParentElement: false,
			independent: true
		});
		if(typeof self.options.initCallback === 'function') self.options.initCallback();
	};

	this.close = function () {
		self.boxEl.style.display = 'none';
		self.hidden=true;
		return false;
	};

	this.highlight = function (element) {
		if (self.activeItem) self.activeItem.classList.remove(self.options.selClass);
		if (element) {
			element.classList.add(self.options.selClass);
			self.activeItem = element;
			element.scrollIntoViewIfNeeded();
		} else {
			self.activeItem = null;
			// self.searchEl.focus();
		}
		return false;
	};

	this.input = function (e) {
		if (e.key == 'Escape') {
			self.close();
			return false;
		} else if (e.key == 'ArrowDown') {
			var renderedItems = self.boxEl.querySelectorAll('[data-type="item"]');
			if(self.value.length >= self.options.minLength){
				if (renderedItems.length && !self.activeItem) {
					self.boxEl.style.display = '';
					self.hidden=false;
					self.highlight(renderedItems[0]);
				} else if (renderedItems.length && self.activeItem.nextElementSibling) {
					self.highlight(self.activeItem.nextElementSibling);
					while (self.activeItem.getAttribute('data-type') === 'heading') {
						self.highlight(self.activeItem.nextElementSibling);
					}
					// if (self.activeItem.offset().top > 130) {
					// 	self.boxEl.scrollTop(self.boxEl.scrollTop() + 16);
					// }
				}
			}
			// return true;
		} else if (e.key == 'ArrowUp') {
			e.preventDefault();
			if (self.activeItem) {
				if (self.activeItem.previousElementSibling) {
					self.highlight(self.activeItem.previousElementSibling);
					while (self.activeItem && self.activeItem.getAttribute('data-type') === 'heading') {
						if (self.activeItem.previousElementSibling) {
							self.highlight(self.activeItem.previousElementSibling);
						} else {
							self.highlight(null);
							self.close();
						}
					}
				} else {
					self.highlight(null);
					self.close();
				}
				// if (self.activeItem.offset().top < self.boxEl.scrollTop()) {
				// 	self.boxEl.scrollTop(self.boxEl.scrollTop() - 16);
				// }
			} else {
				self.highlight(null);
				self.close();
			}
			// return true;
		}
		var val = self.searchEl.value;
		val = val.trim().toLowerCase();
		if (self.options.clearQuotes) val = val.replace(/\'\"/g, '');
		if (self.options.ignoreAccent) val = val.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
		if (self.value !== val) {
			self.value = val;
			self.boxEl.scrollTop=0;
			clearTimeout(self.inputTimer);
			if (self.value && self.value.length >= self.options.minLength) {
				if (!self.filter()) {
					self.inputTimer = setTimeout(self.load, self.options.searchTimeout);
				}
			} else {
				self.close();
			}
		}
	};

	this.filter = function () {
		let d = new Date();
		let t = d.getTime();
		console.log('filter: `' + self.value + '`; timestamp: ' + t);
		if(t > self.submitTimestamp){
			var historyMatch = self.history[self.value];
			if (historyMatch) {
				self.categories = Object.values(historyMatch.categories);
				self.manufacturers = Object.values(historyMatch.manufacturers);
				self.goods = Object.values(historyMatch.goods);
				self.update();
				return true;
			}
			else {
				return false;
			}
		}
	};

	this.load = function () {
		var val = self.value;
		EBContext.ajaxNav.ajaxCall(
			'/?ajax=1&ebPageItemMethod=autocompleteSearch' +
			'&searchText=' + encodeURIComponent(self.value) +
			'&ebPageItemCall=' + self.options.blockName,
			function (response) {
				let data = {};
				try {
					data = JSON.parse(response);
				} catch (error) {
					console.error(error);
				}
				let filterCategories = catsObj=>Object.fromEntries(Object.entries(catsObj).filter(ent=>{
					let catId = EBContext.jsMenu.getCatID(ent[1].SEOID);
					return (catId !== EBContext.data.menuCategories.firstSorting && EBContext.jsMenu.categoryEnabled(catId));
				}));
				self.history[val] = {
					categories: (data && data.category && data.category.data ? filterCategories(data.category.data) : {}),
					manufacturers: (data && data.manufacturer && data.manufacturer.data ? data.manufacturer.data : {}),
					goods: (data && data.good && data.good.data ? data.good.data : {})
				};
				self.filter();
			}, null, {
				loader: self.loader
			}
		);
	};

	this.submit = function (e) {
		let d = new Date();
		let t = d.getTime();
		self.submitTimestamp = t;
		clearTimeout(self.inputTimer);
		console.log('submit: `' + self.value + '`; timestamp: ' + t);
		if (self.activeItem) {
			e.preventDefault();
			e.stopPropagation();
			self.activeItem.click();
			self.close();
			self.highlight(null);
			return false;
		} else {
			self.close();
			self.highlight(null);
			return true;
		}
	};
	
	this.clear = function() {
		while (self.boxEl.firstChild) self.boxEl.removeChild(self.boxEl.firstChild);
	};

	this.update = function (response, options) {
		self.clear();
		if (self.manufacturers.length > 0) {
			self.boxEl.append(EBContext.utils.createDOM('<div class="typeHeading col-12 h5 mt-3" data-type="heading">' + EBContext.resource('VYROBCI') + '</div>')[0]);
			for (let i = 0; i < self.manufacturers.length; i++) {
				self.boxEl.append(self.options.fnGenerateManufacturerEl(self.manufacturers[i]));
			}
		}
		if (self.categories.length > 0) {
			self.boxEl.append(EBContext.utils.createDOM('<div class="typeHeading col-12 h5 mt-3" data-type="heading">' + EBContext.resource('KATEGORIE') + '</div>')[0]);
			for (let i = 0; i < self.categories.length; i++) {
				self.boxEl.append(self.options.fnGenerateCategoryEl(self.categories[i]));
			}
		}
		if (self.goods.length > 0) {
			self.boxEl.append(EBContext.utils.createDOM('<div class="typeHeading col-12 h5 mt-3" data-type="heading">' + EBContext.resource('PRODUKTY') + '</div>')[0]);
			for (let i = 0; i < self.goods.length; i++) {
				self.boxEl.append(self.options.fnGenerateGoodEl(self.goods[i]));
			}
		}
		if (self.boxEl.children.length > 0) {
			EBContext.ajaxNav.bindElements(EBContext.ajaxNav.findElements('link', '#autocompleterBox'), 'link');
			self.boxEl.style.display = '';
			self.hidden=false;
			self.activeItem = null;
		} else {
			self.close();
		}
	};

	this.init();
	return this;
};